import React, { Component } from 'react';
import { connect } from 'react-redux';
import MultiFactorView from './MultiFactor.view';
import config from "../../../../../../config";

export class MultiFactorContainer extends Component {

  constructor(props){
    super(props);
    this.state = {
      formState: {
        data: {
          password: config.mockdata.loginPassword,
        },
      },
      codeFormState: {
        data: {},
      },
    };

    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitCodeForm = this.submitCodeForm.bind(this);
    this.onCodeFormUpdate = this.onCodeFormUpdate.bind(this);
  }

  componentDidMount(){
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_MY_ACCOUNT',
    });
  }

  onFormUpdate(formState) {
    this.setState({
      formState,
    });
  }

  submitForm(formState) {
    const { dispatch } = this.props;
    dispatch({
      type: 'GENERATE_MULTI_FACTOR',
      payload: {
        data: formState.data,
      },
    });
  }

  onCodeFormUpdate(codeFormState) {
    this.setState({
      codeFormState,
    });
  }

  submitCodeForm(codeFormState) {
    const { dispatch } = this.props;
    dispatch({
      type: 'SUBMIT_MULTI_FACTOR_CODE',
      payload: {
        data: codeFormState.data,
      },
    });
  }

  render() {
    return (<MultiFactorView
      {...this.props}
      {...this.state}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
      onCodeFormUpdate={this.onCodeFormUpdate}
      submitCodeForm={this.submitCodeForm}
    />);
  }

}

function mapStateToProps(state) {
  const { multiFactor } = state;
  const { user, qrCode } = multiFactor;
  return {
    user,
    qrCode,
  };
}

export default connect(mapStateToProps)(MultiFactorContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MultiFactor/MultiFactor.container.js